module.exports = __webpack_public_path__ + "img/MOBILE-VTA-VALORACION-REAGENDADA.675b4891.png";